import React from "react";
import { IonSpinner } from "@ionic/react";

const BLLoadingContainer = ({ color = "primary", type = "crescent", newClasses = "bl-margin-s" }) => {
  return <IonSpinner className={newClasses} color={color} name={type} />;
};

export default BLLoadingContainer;
